<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showSnackBar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-center text-center>
      <v-flex xs12 sm6 md2>
        <v-text-field label="username" v-model="userName"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md1 align-self-center>
        <v-btn small @click="removeUser">Remove</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      timeout: 10000,
      showSnackBar: false,
      userName: null,
      msg: null
    };
  },
  methods: {
    removeUser() {
      axios({
        method: "GET",
        url: "/remove/userbyusername",
        params: {
          code: "qscef",
          username: this.userName
        }
      }).then(response => {
        if (response.data.status) {
          this.msg = "Removed";
          this.showSnackBar = true;
        }
      });
    }
  }
};
</script>
